import axios from "axios";
import {blogUrl} from "../../config";
import {types} from "./../types/globalTypes";
import {blogTypes} from "../types/blogTypes";

export const getPostsListsPage = (page = 1, queryString = "categories", keyword = "", limit = 2, footer = false) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });

        axios.get(blogUrl + "?action=" + queryString + "&limit=" + limit + "&page=" + page + "&keyword=" + keyword).then(response => {

            if (response.data.code === 200) {
                if (!footer) {
                    dispatch({
                        type: blogTypes.GET_POSTS_LIST,
                        payload: response.data.data
                    })
                } else {
                    dispatch({
                        type: blogTypes.GET_FOOTER_POSTS_LIST,
                        payload: response.data.data
                    })
                }

            } else {
                dispatch({
                    type: blogTypes.GET_POST_NOT_FOUND,
                    payload: true
                })
            }
        }).catch(error => {
            console.log(error);
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        })

    };
};

export const getPostDetails = (slug) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });

        axios.get(blogUrl + "?action=post&slug=" + slug).then(response => {
            if (response.data.code === 200) {
                //console.log(response.data)
                // set page title
                document.title = (response.data && response.data.data && response.data.data.post)  ? response.data.data.post.post_title: "Post details ...";

                dispatch({
                    type: blogTypes.GET_POST_DETAILS,
                    payload: response.data.data
                })
            } else {
                dispatch({
                    type: blogTypes.GET_POST_DETAILS_NOT_FOUND,
                    payload: true
                })
            }
        }).catch(error => {

            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        })

    };
};

export const sendBlogComment = (data) => {

    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        dispatch({
            type: blogTypes.ADDING_COMMENT_STATUS,
            payload: true,
        });
        axios({
            method: 'post',
            url: blogUrl + "?action=add_comment",
            headers: {'content-type': 'application/json'},
            data: data
        }).then(response => {
            dispatch({
                type: blogTypes.ADDING_COMMENT_STATUS,
                payload: false,
            });
            if (response.data.code === 200) {
                dispatch({
                    type: blogTypes.SEND_BLOG_COMMENT,
                    payload: response.data.data
                })
            }
        }).catch(error => {
            console.log(error);
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        })

    };
};
export const clearBlogData = () => {
    return (dispatch, getState) => {
        dispatch({
            type: blogTypes.CLEAR_BLOG_DATA,
            payload: []
        });
    }
};
